<template>
    <payment 
        ref="payment"
        @pending="pending"   
        @register_error="registerError"
    >
        <payment-form 
            :internalErrors="errors"
            @submitForm="submitForm"
        />
        <modal-iframe 
            url="/payments/iframes/konntransacteuro"
            :data="iframeData"
        />
    </payment>
</template>

<script>

import PaymentForm from '../../forms/PaymentForm';
import IframeModal from '../../modals/IframeModal';
import Payment from '../PaymentContainer';

export default {
    components: {
         PaymentForm, Payment, IframeModal
    }, 
    data() {
        return {
            errors: [],
            iframeData: {},
        }
    },
    mounted(){},
    methods: {
        registerError(data){
            this.errors = data;    
        },

        submitForm(data){
            data.browserData = this.getBrowserData ();
            this.$refs.payment.processPayment(data);
        },

        pending(data){
            this.iframeData = data.data;
        },
    
        getBrowserData () {
            const navigator = window.navigator;
            return JSON.stringify({
                acceptHeader: 'application/json',
                userAgent: navigator.userAgent,
                language: navigator.language,
                timezone: (new Date()).getTimezoneOffset().toString(),
                colorDepth: screen.colorDepth,
                screen: {
                    height: screen.height.toString(),
                    width: screen.width.toString()
                },
                javaScriptEnabled: true,
                javaEnabled: navigator.javaEnabled()
            });
        },
    }
}
</script>
